<!-- .block-categories -->
<div class="block block--highlighted block-categories block-categories--layout--{{ layout }}" *ngIf="categories?.length">
    <div class="container">
        <app-block-header [header]="header"></app-block-header>

        <div class="block-categories__list">
            <div *ngFor="let category of categories" class="block-categories__item category-card category-card--layout--{{ layout }}">
                <div class="category-card__body">
                    <div class="category-card__image">
                        <a [routerLink]="root.category(category)">
                            <!-- <app-icon class="cat-ico" [name]="category.image" size="56"></app-icon>  -->
                             <!-- Root-absolute, not "../../../../assets/...". A browser resolves that against
                                  <base href="/"> and clamps the extra steps back to the root, so it looked fine,
                                  but anything that asks for the path as written gets 400 off the edge of the
                                  site - and these cards carry the category images on four pages. -->
                             <img loading="lazy" [alt]="category.name" src="/assets/images/categories/{{category.image}}.png" />
                        </a>
                    </div>
                    <div class="category-card__content">
                        <div class="category-card__name">
                            <a [routerLink]="root.category(category)">{{ category.name | tCategory }}</a>
                        </div>
                        <ul class="category-card__links">
                            <li *ngFor="let category of category.children.slice(0, 5)">
                                <a [routerLink]="root.category(category)">{{ category.name | tCategory }}</a>
                            </li>
                        </ul>
                        <!-- <div class="category-card__all">
                            <a [routerLink]="root.category(category)">Show All</a>
                        </div> -->
                        <p class="category-card__subtitle" *ngIf="category.subtitle">{{ category.subtitle }}</p>
                        <!-- Live, from what is listed: never a count, never a claim the catalogue cannot back. -->
                        <div class="category-card__badges" *ngIf="highlights[category.slug] as h">
                            <span class="category-card__badge category-card__badge--new" *ngIf="h.NewThisWeek">
                                <i class="category-card__pulse" aria-hidden="true"></i>{{ 'new-this-week' | t:'New this week' }}
                            </span>
                            <span class="category-card__badge category-card__badge--fresh" *ngIf="!h.NewThisWeek && h.NewThisMonth">{{ 'new-this-month' | t:'New this month' }}</span>
                            <span class="category-card__badge category-card__badge--price" *ngIf="h.FromPrice > 0">{{ 'category-from-price' | t:'From {price}':{ price: (h.FromPrice | currencyFormat) } }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- .block-categories / end -->
